export default "__VITE_ASSET__XlGwtqQH__"